import { INJECT_BUTTON_TO_FOOTER_LINKS_SECTION } from './footer.actions';
import { LinkButton } from '../utils/oldNavigation.utils';

type Link = {
  text: string;
  href: string;
};

export type ImageLink = {
  alt: string;
  href: string;
  src: string;
};

export interface NavigationLink {
  link: Link;
  children: NavigationLink | null;
}

export interface FooterState {
  linksSection: {
    title: string;
    links: Array<NavigationLink>;
    buttons?: Array<LinkButton>;
  } | null;
  socialSection: {
     title: string;
     imageLinks: Array<ImageLink>;
  } | null;
  appsSection: {
     title: string;
     imageLinks: Array<ImageLink>;
  } | null;
  bottomFooterBar: {
     year: number;
     rightsReservedText: string;
     poweredByLink: Link;
  };
}

interface InjectButtonToFooterLinksSectionAction {
  type: typeof INJECT_BUTTON_TO_FOOTER_LINKS_SECTION;
  text: string;
  onClick: string;
}

export type FooterAction = InjectButtonToFooterLinksSectionAction;

export const footerReducer = (state: FooterState = {} as FooterState, action: FooterAction) => {
  switch (action.type) {
    case INJECT_BUTTON_TO_FOOTER_LINKS_SECTION: {
       const { text, onClick } = action;
       const buttons = state.linksSection && state.linksSection.buttons;
       return {
         ...state,
         linksSection: {
           ...state.linksSection,
           buttons: [
             ...(buttons || []),
             {
               text,
               onClick,
             },
           ],
         },
       };
    }
    default:
      return state;
  }
};
